import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'stay-mgmt-view-my-account',
  templateUrl: './view-my-account.component.html',
  styleUrls: ['./view-my-account.component.scss']
})
export class ViewMyAccountComponent implements OnInit {
  @Input() messages;

  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/view-my-account/view-my-account.component.ts